import Accordion from '@theme/components/utils/Accordion'
import ContentBuilderBlock from '@/mixins/ContentBuilderBlock.vue'

export default {
  name: 'AccordionsBlock',
  mixins: [ContentBuilderBlock],
  cmsSettings: {
    type: 'accordions',
  },
  components: {
    Accordion,
  },
  data() {
    return {
      accordions: [],
    }
  },
  created() {
    this.accordions = this.block.accordion_reference.map(ref => {
      const accordion = { ...ref.entity }
      const titleParts = accordion.title.split(':')

      accordion.title = titleParts[0].trim()
      accordion.subtitle = titleParts[1]?.trim()

      return accordion
    })
  },
  query() {
    return `
      ... on block_accordions {
        type
        uuid
        accordion_reference {
          entityId
          entity {
            ... on accordion {
              _id
              title
              content
              main_image {
                path
                alt
              }
            }
          }
        }
      }
    `
  },
}
